export class ApplicationPropertyDto {
    apn: string;
    unsecuredNum: string;
    rollYear: string;
    accountTaxNum: string;
    strNum: string;
    street: string;
    city: string;
    type: string;
    secured: string;
    useCode: string;
    taxRateArea: string;
    ownOccupied: boolean;
    apnMismatch: boolean;
    public create() {
        return {
            apn: '',
            unsecuredNum: '',
            rollYear: '',
            accountTaxNum: '',
            strNum: '',
            street: '',
            city: '',
            type: '',
            secured: '',
            useCode: '',
            taxRateArea: '',
            ownOccupied: false,
            apnMismatch: false,
        }
    
    }
}
